<script setup lang="ts">
import {defineProps} from "vue";

const props = defineProps<{
    message: string
    type: string
}>()
</script>

<template>
    <div class="fixed inset-0 z-[999] grid h-screen w-screen place-items-center">
        <div class="bg-mono-ns-100 rounded-3xl flex flex-col p-6 xl:p-10 font-sans items-center gap-4">
            <div class="rounded-full p-3 bg-sa-light text-mono-ns-100">
                <svg class="w-6 h-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 6.5L9 17.5L4 12.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
            </div>
            <h3>{{ props.message }}</h3>
        </div>
    </div>
</template>

